/* Four repairs inside the VIN modal: the header, the cart, the site menu, and
   the drift dialog's missing trailer renders.

   THE HEADER. The modal covers the viewport, so for as long as it is open the
   extension's floating button cluster is the only header the customer has, and
   a cluster of circles in the top right corner is not a header. It gets the
   site's own lockup on the left and becomes a real bar: white, ruled, pinned
   to the top of the scroller. The logo is read off the theme header rather
   than hardcoded, so whatever is set in the theme editor appears here.

   --fx-mpad is measured, not assumed. The bar has to bleed out to the edges of
   a scroller whose padding is 56px on a desktop and something else on a phone,
   and reading it once is cheaper and more honest than keeping a copy of the
   extension's breakpoints in this theme.

   THE CART BUTTON GETS THE THEME'S OWN ATTRIBUTE. Outside the modal the cart
   opens the slide out drawer; inside it, the extension's button was still a
   plain link to /cart, so the same icon did two different things depending on
   which layer it was drawn in. Tagging it with data-fx-cart-open hands it to
   assets/fx-cart.js, which lifts the drawer over the modal. The href stays,
   so with JavaScript off it is still a link to the cart page.

   THE DRIFT DIALOG IS SHIPPING A BROKEN src AND IT IS NOT A CSS PROBLEM. Read
   the markup the extension writes for "Which trailer are these parts for?":

       <span class="vin-fx-drift-shot"><img src="[object Object]" alt=""></span>

   Something is handing the <img> the render OBJECT where it wants the object's
   url, so the browser requests a file called "[object Object]", gets a 404,
   and the customer is asked to choose between two empty grey boxes. The real
   fix is one line in the extension and it needs a deploy; this puts a picture
   back in the meantime, from sources already on the page.

   THE MENU opens the theme's own mobile panel, lifted over the modal by a
   class, so it is the same menu with the same links rather than a second one
   to maintain. It is not offered while the modal is still searching.

   THE DEBOUNCE IS setTimeout AND NOT requestAnimationFrame, AND THAT IS NOT A
   STYLE CHOICE. rAF does not run in a tab that is not being painted: a
   mutation sets the queued flag, the frame never comes, the flag is never
   cleared, and every mutation after that is dropped on the floor. A timer
   always fires. */
(function () {
  var queued = null;

  /* ------------------------------------------------------------- menu -- */
  /* Three lines. Two reads as a list, or as something half drawn. */
  var MENU_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"' +
    ' stroke-linecap="round" aria-hidden="true">' +
    '<path d="M4 6.75h16M4 12h16M4 17.25h16"/></svg>';

  function addMenu() {
    var bar = document.querySelector('.vin-modal-toolbar');
    if (!bar || bar.querySelector('.fx-mmenu')) return;
    var panel = document.querySelector('.fx-panel');
    if (!panel) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fx-mmenu';
    btn.setAttribute('aria-label', 'Menu');
    btn.innerHTML = MENU_SVG;

    btn.addEventListener('click', function () {
      panel.classList.remove('is-cart');
      panel.classList.add('fx-panel--over');
      panel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      panel.querySelectorAll('[data-fx-burger]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    });

    bar.insertBefore(btn, bar.firstChild);
  }

  /* ------------------------------------------------------------- logo -- */
  function addLogo() {
    var bar = document.querySelector('.vin-modal-toolbar');
    if (!bar || bar.querySelector('.fx-mlogo')) return;
    var src = document.querySelector('.fx-brand img');
    if (!src) return;
    var url = src.currentSrc || src.getAttribute('src');
    if (!url) return;

    var a = document.createElement('a');
    a.className = 'fx-mlogo';
    a.href = '/';
    a.setAttribute('aria-label', 'Futura Trailers Parts Store');

    var img = document.createElement('img');
    img.src = url;
    img.alt = src.getAttribute('alt') || 'Futura Trailers';
    a.appendChild(img);

    bar.insertBefore(a, bar.firstChild);
  }

  /* One cart icon, one behaviour, whichever layer it is drawn in. */
  function tagCart() {
    document.querySelectorAll('.vin-modal-cart').forEach(function (a) {
      if (!a.hasAttribute('data-fx-cart-open')) a.setAttribute('data-fx-cart-open', '');
    });
  }

  /* The bar bleeds to the edge of the scroller, and only the scroller knows
     how wide its own padding is at this viewport. */
  function setPad() {
    var c = document.querySelector('.vin-modal-content');
    if (!c) return;
    var pad = window.getComputedStyle(c).paddingLeft;
    if (pad) c.style.setProperty('--fx-mpad', pad);
  }

  /* ------------------------------------------------------------ drift -- */
  function isUrl(s) {
    return typeof s === 'string' && /^(https?:|\/\/|\/)/.test(s);
  }

  function carouselRenders() {
    var out = [];
    document.querySelectorAll('.ident-card').forEach(function (card) {
      var name = card.querySelector('.ident-card-name');
      var img = card.querySelector('.ident-media img');
      if (!name || !img) return;
      var src = img.getAttribute('src') || img.currentSrc;
      if (!isUrl(src)) return;
      out.push({ name: name.textContent.trim(), src: src });
    });
    // Longest name first, so "Super Sport" is not matched by "Sport".
    out.sort(function (a, b) { return b.name.length - a.name.length; });
    return out;
  }

  function matchRender(list, label) {
    // Labels read "2025 Super Sport" or "2026 SHIFTR 1883". The year is not
    // part of any model name, so it goes before anything is compared.
    var text = String(label || '').replace(/\b(19|20)\d{2}\b/g, ' ').toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (list[i].name && text.indexOf(list[i].name.toLowerCase()) > -1) return list[i].src;
    }
    return null;
  }

  function matchedRender() {
    var imgs = document.querySelectorAll('.vin-fx-trailer-img');
    for (var i = 0; i < imgs.length; i++) {
      var src = imgs[i].getAttribute('src') || imgs[i].currentSrc;
      if (isUrl(src)) return src;
    }
    return null;
  }

  function fixDrift() {
    var shots = document.querySelectorAll('.vin-fx-drift-shot img');
    if (!shots.length) return;

    var list = null;
    for (var i = 0; i < shots.length; i++) {
      var img = shots[i];
      if (isUrl(img.getAttribute('src'))) continue;
      if (img.getAttribute('data-fx-drift-done')) continue;
      img.setAttribute('data-fx-drift-done', '1');

      if (!list) list = carouselRenders();

      var opt = img.closest('.vin-fx-drift-opt');
      var label = opt && opt.querySelector('.vin-fx-drift-name');
      var src = matchRender(list, label ? label.textContent : '');

      if (!src && opt && opt.classList.contains('vin-fx-drift-opt--vin')) {
        src = matchedRender();
      }

      if (src) img.setAttribute('src', src);
      else img.remove();
    }
  }

  function pass() {
    queued = null;
    try { addMenu(); } catch (e) { /* toolbar not built yet */ }
    try { addLogo(); } catch (e) { /* toolbar not built yet */ }
    try { tagCart(); } catch (e) { /* toolbar not built yet */ }
    try { setPad(); } catch (e) { /* content not built yet */ }
    try { fixDrift(); } catch (e) { /* dialog not built yet */ }
  }

  function schedule() {
    if (queued) return;
    queued = window.setTimeout(pass, 60);
  }

  function boot() {
    pass();
    window.addEventListener('resize', schedule);
    if (!window.MutationObserver) return;
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
